import { render, staticRenderFns } from "./Allergens.vue?vue&type=template&id=2b12edc6&scoped=true&"
import script from "./Allergens.vue?vue&type=script&lang=js&"
export * from "./Allergens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12edc6",
  null
  
)

export default component.exports